// ** React Imports
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import { useLocation } from 'react-router-dom';

// ** Hooks Import (Assuming this is your custom hook)
import { useAuth } from 'hooks/auth/useAuth';

// eslint-disable-next-line react/prop-types
const AuthGuard = ({ children, fallback }) => {
  const auth = useAuth();
  const navigate = useNavigate(); // Use useNavigate instead of useHistory
  const location = useLocation();

  useEffect(() => {
    if (!navigate) {
      return;
    }
    if (auth.user === null && !window.localStorage.getItem('kerpUserData2.1')) {
      if (location.pathname !== '/') {
        navigate('/auth/login', {
          state: { returnUrl: location.pathname },
          replace: true
        }); // Add replace: true
      } else {
        navigate('/auth/login', { replace: true }); // Also add replace: true here
      }
    }
  }, [navigate, auth.user]);

  if (auth.loading) {
    return fallback;
  }

  return <>{children}</>;
};

export default AuthGuard;
